import type { ReactNode } from "react";

/** The Nova wordmark, the same path the registration prototype ships. currentColor so a theme recolours it. */
export function NovaWordmark({ className }: { readonly className?: string | undefined }): ReactNode {
  return (
    <svg
      className={className}
      viewBox="0 0 169.5 44.4"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Nova"
    >
      <path
        fill="currentColor"
        d="M167.3.3c-9.7,0-19.8,0-19.9,0-8.6,0-16.1,4.9-19.7,12.1V2.2c0-1.2-1-2.2-2.2-2.2h-39.7c-1.2,0-2.2,1-2.2,2.2v10.2C79.9,5.2,72.5.3,63.9.3s-17.9,6.2-20.9,14.9C40,6.5,31.8.3,22.1.3h-7.6c-1.3,0-2.5.4-3.6,1L1,7.7c-.6.4-1,1.1-1,1.9,0,9.9,0,25.5,0,32.7,0,1.2,1,2.2,2.2,2.2h39.7c1.2,0,2.2-1,2.2-2.2,0-3.2,0-6.7,0-9.9,3.6,7.2,11.1,12.1,19.7,12.1s19.4-7.5,21.6-17.4c3.4,3.4,10.6,10.6,15.5,15.5,2.6,2.6,6.9,2.6,9.5,0,4.8-4.8,12.1-12.1,15.5-15.5,2.1,10,11,17.4,21.6,17.4h8.2c1.3,0,2.5-.4,3.6-1.1l9.3-6.1c.6-.4,1-1.1,1-1.8V2.5c0-1.2-1-2.2-2.2-2.2"
      />
    </svg>
  );
}

export type VisitorLogo = {
  readonly src: string | null;
  readonly name: string;
};

export function VisitorMark({
  logo,
  className,
}: {
  readonly logo: VisitorLogo;
  readonly className?: string | undefined;
}): ReactNode {
  if (logo.src !== null && logo.src !== "") {
    return <img className={className} src={logo.src} alt={logo.name} />;
  }
  return <NovaWordmark className={className} />;
}
